import Link from 'next/link';
import cn from 'classnames';

import SpeakerAvatar from 'react-scale/components/pages/transformx/speakers/speakerAvatar';

const SpeakerCard = ({ speaker, idx, useNewAvatar = false, newCard = false }) => (
  <li className="relative overflow-hidden rounded-md cursor-pointer h-[340px] bg-codGray group">
    <Link href={`/events/transformx/speakers/${speaker.slug}`}>
      <a>
        <div className="relative flex flex-col h-full bg-codGray">
          <SpeakerAvatar
            avatar={speaker.avatar}
            name={speaker.name}
            idx={idx}
            useNewAvatar={useNewAvatar}
          />
          <div
            className={cn(
              'card-animation z-10 flex flex-col justify-between w-full h-56 px-4 pb-4 translate-y-28 group-hover:translate-y-0 -mt-28 bg-codGray',
              { 'text-left': newCard }
            )}
          >
            <div>
              <p className={cn('text-lg line-clamp-1 mt-4 mb-2 font-semibold')}>{speaker.name}</p>
              <div className="line-clamp-2 group-hover:line-clamp-5">
                <p className="text-sm">
                  {speaker.positions.map(position => (
                    <span>
                      {position.text}, {position.companyName}
                    </span>
                  ))}
                </p>
              </div>
            </div>
            <div
              className={cn(
                'flex w-full',
                { 'justify-start': newCard },
                { 'justify-center': !newCard }
              )}
            >
              <p className="inline-block text-transform-x-gradient w-fit">View Profile &rarr;</p>
            </div>
          </div>
        </div>
      </a>
    </Link>
  </li>
);

export default SpeakerCard;
